import { themeColors } from "@common/constants";

export const ASSET_COLORS = [
  themeColors.data.blue,
  themeColors.data.red,
  themeColors.data.green,
  themeColors.data.yellow,
  themeColors.data.lightblue,
];
export const DATE_FORMAT = "M/D/YYYY";
export enum OrionEntityName {
  Household = "Household",
  Registration = "Registration",
  Account = "Account",
}

export const BASE_URL = "/v1/accounts";

export enum PerformancePeriod {
  TwelveMonth = "12_MONTH",
  Ytd = "YTD",
  LastYear = "LAST_YEAR",
}

// Exhaustive: the Record type forces a label for every PerformancePeriod, so
// callers can look up a label without a (potentially misleading) fallback.
export const PERFORMANCE_PERIOD_LABELS: Record<PerformancePeriod, string> = {
  [PerformancePeriod.TwelveMonth]: "12 Month",
  [PerformancePeriod.Ytd]: "YTD",
  [PerformancePeriod.LastYear]: "Last Year",
};

// Display order for the period selector.
export const PERFORMANCE_PERIOD_OPTIONS: {
  id: PerformancePeriod;
  label: string;
  value: PerformancePeriod;
}[] = [
  PerformancePeriod.TwelveMonth,
  PerformancePeriod.Ytd,
  PerformancePeriod.LastYear,
].map((value) => ({
  id: value,
  value,
  label: PERFORMANCE_PERIOD_LABELS[value],
}));

export const DEFAULT_PERFORMANCE_PERIOD = PerformancePeriod.TwelveMonth;

// Shown to a household whose investments are unlocked but whose Orion linkage
// has not landed yet. Deliberately not the ZeroState upsell: these clients have
// already bought the service, so the lock glyph and purchase CTA would be wrong.
export const PENDING_SETUP_COPY = {
  title: "We're setting up your investment accounts",
  body: "Your portfolio will appear here once your accounts finish onboarding. Your advisor can share a timeline.",
};
